export default __webpack_public_path__ + "static/orsusecase1-3ee6bfdfaf5c506b921db921676a9f95.jpg";